<mat-icon [svgIcon]="icon()" [style.width.px]="size()" [style.height.px]="size()" aria-hidden="true" />
